import React from 'react';
import {
	styled,
	Icon
} from 'ps-gui';

export default class CheckButton extends React.PureComponent {
	onChange() {
		if (this.props.onChange) {
			this.props.onChange(!this.props.value);
		}
	}

	render() {
		return (
			<Wrapper
				className={'checkButton ' + (this.props.value ? 'on' : 'off')}
				onMouseDown={e => {
					e.preventDefault();
					this.onChange();
				}}
				marginLeft={this.props.marginLeft}
			>
				<Icon
					name="buttonCheck"
				/>
				<span className="text">
					{this.props.text}
				</span>
				{
					this.props.rightIcon &&
						<Icon
							className="right"
							name={this.props.rightIcon}
						/>

				}
			</Wrapper>
		);
	}
}

const Wrapper = styled.div`
	cursor: pointer;
	display: inline-block;
	font-weight: 500;
	font-size: 14px;
	padding: 4px 16px;
	border-radius: 16px;
	border: 1px solid #306DA0;
	background: #F3FAFD;
	color: #306DA0;
	margin-left: ${props => props.marginLeft};
	.icon[data-name=buttonCheck] {
		margin-right: 8px;
	}
	.text {
		vertical-align: middle;
	}
	&:hover {
		.text {
			text-decoration: underline;
		}
	}
	.icon.right {
		margin-left: 8px;
	}

	&.off {
		background: #ECECEC;
		color: #575757;
		border-color: #575757;
		.icon[data-name=buttonCheck] {
			visibility: hidden;
			display: none;
		}
		.icon.right {
			opacity: 0.4;
		}
	}
`;

